// 产品详情展开/收起功能
document.addEventListener('DOMContentLoaded', function() {
  // 查找所有产品详情section
  const detailsSections = document.querySelectorAll('.product-details-expandable');
  
  detailsSections.forEach(section => {
    const sectionId = section.id.replace('product-details-section-', '');
    const imageContainer = document.getElementById('details-image-container-' + sectionId);
    const detailsImage = document.getElementById('details-image-' + sectionId);
    const gradient = document.getElementById('details-gradient-' + sectionId);
    const toggleButton = document.getElementById('toggle-details-button-' + sectionId);
    
    if (!imageContainer || !detailsImage || !gradient || !toggleButton) return;
    
    // 从section数据属性中获取最大高度，默认为800px
    const maxHeight = parseInt(section.dataset.maxHeight || 800);
    imageContainer.style.maxHeight = maxHeight + 'px';
    
    // 设置初始图片大小
    detailsImage.onload = function() {
      // 如果图片高度小于容器初始高度，隐藏按钮和渐变
      if (detailsImage.naturalHeight <= maxHeight) {
        toggleButton.style.display = 'none';
        gradient.style.display = 'none';
        imageContainer.style.maxHeight = 'none'; // 直接显示完整图片
      }
    };
    
    // 检查图片是否已经加载完成
    if (detailsImage.complete) {
      detailsImage.onload();
    }
    
    // 切换按钮功能
    toggleButton.addEventListener('click', function() {
      if (imageContainer.classList.contains('expanded')) {
        // 收起图片
        imageContainer.classList.remove('expanded');
        imageContainer.style.maxHeight = maxHeight + 'px';
        gradient.style.opacity = '1';
        toggleButton.textContent = toggleButton.dataset.showMoreText || 'Show More';
        // 滚动到图片顶部
        imageContainer.scrollIntoView({behavior: 'smooth'});
      } else {
        // 展开图片
        imageContainer.classList.add('expanded');
        imageContainer.style.maxHeight = 'none';
        gradient.style.opacity = '0';
        toggleButton.textContent = toggleButton.dataset.showLessText || 'Show Less';
      }
    });
  });
});
